import type { ListsStore } from '@stores/lists/interfaces'
import type { ConfigTasksKanban, PropertiesTasksKanban } from '@ts-lists/interfaces'
import type { ExtraFields, TaskTypes } from '@ts-lists/types'

const getTasksKanbanList = (state: ListsStore): PropertiesTasksKanban | null => state.lists?.tasks_kanban?.lists || null
const getTasksKanbanConfig = (state: ListsStore): ConfigTasksKanban | null => state.lists?.tasks_kanban?.config || null

export const tasksKanban = {
  getTasksKanbanList: (state: ListsStore): PropertiesTasksKanban | null => getTasksKanbanList(state),
  getTasksKanbanConfig: (state: ListsStore): ConfigTasksKanban | null => getTasksKanbanConfig(state),
  getTaskTypes: (state: ListsStore): TaskTypes | null => getTasksKanbanConfig(state)?.task_types || null,
  getExtraFields: (state: ListsStore): ExtraFields | null => getTasksKanbanConfig(state)?.extra_fields || null,
  getExtraFieldsLists: (state: ListsStore): Record<string, string> | null => getTasksKanbanList(state)?.extra_fields || null,
}
